import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PolarisChoice {
  title: string;
  description?: string;
  trailing?: string;
  selected?: boolean;
}

@Component({
  selector: 's-polaris-choice-list',
  templateUrl: './s-polaris-choice-list.component.html',
  styleUrls: ['./s-polaris-choice-list.component.scss'],
  standalone: false,
})
export class PolarisChoiceListComponent {
  @Input() variant: 'block' | 'list' = 'block';
  @Input() choices: PolarisChoice[] = [];

  @Output() choiceSelected = new EventEmitter<number>();
}
